export const dollarUS = (number, maximumSignificantDigits = 10) => {
  if (isNaN(number)) return "$0";
  return Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumSignificantDigits,
    minimumFractionDigits: 2,
  }).format(number);
};

export const capitalizeWords = (str) => {
  return str
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};
